module.exports = __webpack_public_path__ + "img/imgYLSYB(4).f4675b1f.png";